(() => {
	const btns = document.querySelectorAll('.activityIndicatorButtons .ancBtn');
	for (let i = 0; i < btns.length; i++) {
		btns[i].addEventListener('click', e => {
			const btn = e.currentTarget;
			btn.querySelector('.hideVisually').classList.remove('hideVisually');
			if (btn.classList.contains('loading')) {
				btn.classList.remove('loading');
				btn.removeAttribute('aria-busy');
				btn.lastChild.classList.add('hideVisually');
			} else {
				btn.setAttribute('aria-busy', 'true');
				btn.classList.add('loading');
				btn.firstChild.classList.add('hideVisually');
			}
		});
	}
})();



// WEBPACK FOOTER //
// ./src/components/activity-indicator/activity-indicator.demo.js